import * as msal from '@azure/msal-browser';

import { loginRequest, msalConfig } from 'src/auth/config';
import store from 'src/redux/store';

export const msalApp = new msal.PublicClientApplication(msalConfig);
export const msalInitialized = msalApp.initialize();

export async function msSignIn() {
  await msalInitialized;
  msalApp.loginRedirect(loginRequest);
}

export async function msSignOut() {
  await msalInitialized;
  await msalApp.logoutRedirect();
}

export async function getTokenRedirect(
  request: msal.RedirectRequest = loginRequest,
  account: msal.AccountInfo | null = null,
) {
  await msalInitialized;

  const customLoginData = store.getState()?.auth;

  if (customLoginData?.accessToken) {
    const { accessToken } = customLoginData;

    return {
      accessToken,
      account: null,
    };
  }

  let requestAccount = account;
  if (requestAccount === null) {
    const accounts = await msalApp.getAllAccounts();
    if (accounts && accounts.length === 1) {
      requestAccount = accounts[0];
    }
  }
  request = { ...request, account: requestAccount };
  if (!requestAccount) {
    msSignIn();
    return null;
  }

  return await msalApp.acquireTokenSilent(request).catch(error => {
    if (error instanceof msal.InteractionRequiredAuthError) {
      console.log('Silent token acquisition fails! ');
      console.log('Acquiring token using redirect.');
      return msalApp.acquireTokenRedirect(request);
    }
    throw error;
  });
}

export function seeProfile() {
  return getTokenRedirect(loginRequest);
}
